const selectors = {
  holderItems: '[data-custom-scrollbar-items]',
  scrollbar: '[data-custom-scrollbar]',
  scrollbarTrack: '[data-custom-scrollbar-track]',
};

const classes = {
  hide: 'hide',
};

const sections = {};

class CustomScrollbar {
  constructor(holder, children = null) {
    this.holderItems = holder.querySelector(selectors.holderItems);
    this.scrollbar = holder.querySelector(selectors.scrollbar);
    this.scrollbarTrack = holder.querySelector(selectors.scrollbarTrack);
    this.trackWidth = 0;
    this.scrollWidth = 0;

    if (this.scrollbar && this.holderItems) {
      this.children = children || this.holderItems.children;
      this.events();
      this.calculateTrackWidth();
    }
  }

  events() {
    this.holderItems.addEventListener('scroll', this.calculatePosition.bind(this));
    this.holderItems.addEventListener('theme:carousel:scroll', this.calculatePosition.bind(this));

    document.addEventListener('theme:resize:width', this.calculateTrackWidth.bind(this));
    document.addEventListener('theme:resize:width', this.calculatePosition.bind(this));
  }

  calculateTrackWidth() {
    // Javascript can't execute calc() (from `--outer` variable) - create a new div with width property instead `getPropertyValue('--outer')` to can get the width of `after` on the holder
    const htmlObject = document.createElement('div');
    this.holderItems.prepend(htmlObject);
    htmlObject.style.display = 'none';
    htmlObject.style.width = getComputedStyle(this.holderItems).getPropertyValue('--outer');
    const widthAfter = parseInt(getComputedStyle(htmlObject).getPropertyValue('width'));
    this.holderItems.firstChild.remove();

    this.scrollbarWidth = this.scrollbar.clientWidth === 0 ? this.scrollbar.parentNode.getBoundingClientRect().width : this.scrollbar.clientWidth;
    setTimeout(() => {
      const childWidth = this.children[0].clientWidth;
      const childMarginRight = Number(getComputedStyle(this.children[0]).marginRight.replace('px', ''));
      const childMarginLeft = Number(getComputedStyle(this.children[0]).marginLeft.replace('px', ''));

      // Minus `childMarginRight` is added to the end with minus because the last child doesn't have margin-right
      this.scrollWidth = this.children.length * (childWidth + childMarginRight + childMarginLeft) + widthAfter - childMarginRight;

      this.trackWidth = ((this.scrollbarWidth + widthAfter) / this.scrollWidth) * 100;
      this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth;
      this.scrollbar.style.setProperty('--track-width', `${this.trackWidth}%`);
      const hideScrollbar = Math.ceil(this.trackWidth) >= 100;

      this.scrollbar.classList.toggle(classes.hide, hideScrollbar);
    }, 100);
  }

  calculatePosition() {
    let position = this.holderItems.scrollLeft / (this.holderItems.scrollWidth - this.holderItems.clientWidth);
    position *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth;
    position = position < 0 ? 0 : position;
    position = isNaN(position) ? 0 : position;

    this.scrollbar.style.setProperty('--position', `${Math.round(position)}px`);

    document.dispatchEvent(
      new CustomEvent('theme:scrollbar:scroll', {
        bubbles: true,
        detail: {
          holder: this.holderItems,
        },
      })
    );
  }
}

const customScrollbar = {
  onLoad() {
    sections[this.id] = new CustomScrollbar(this.container);
  },
};

export {CustomScrollbar, customScrollbar};
